export default {"src":"/_next/static/media/right-arrow-icon.e14a7d77.svg","height":21,"width":20,"blurWidth":0,"blurHeight":0};